import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchApiData } from "../../redux/reducers/commonApiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import {
  fitness_profile_logs,
  user_feedback_logs,
} from "../../data/ApiEndpoints";
import { fixedTwo, formatDateTimezon } from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const DetailedLogs = ({ from, rowData, userInfoData }) => {
  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: rowData?.user_id || "",
    trainer_id: rowData?.trainer_id || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    pagination: [],
    allDetailData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
    remarks: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  function getDetails(filters, endpoint) {
    const { trainer_id, ...rest } = filters || {};

    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: from === "fitness_profile_logs" ? rest : filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.user_id) {
      getDetails(
        filters,
        from === "fitness_profile_logs"
          ? fitness_profile_logs
          : from === "trainer_rating_logs"
          ? user_feedback_logs
          : ""
      );
    }
  }, [filters]);

  useEffect(() => {
    if (!loading && data?.status && data?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allDetailData: data.data,
        pagination: data?.pagination?.length > 0 ? data.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [data, loading]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  if (!loading && allDatas.allDetailData?.length === 0) {
    return (
      <div className="error-container">
        <p>No trainer rating logs found for this member.</p>
      </div>
    );
  }

  const tbColumnsFitnessLogs = [
    {
      dataField: "date",
      text: "Date added",
      formatter: (_, row) => {
        return <span className="tb-data minWidth100">{row?.date || "-"}</span>;
      },
    },
    {
      dataField: "user_id",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "age",
      text: "age",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.age || "-"}</span>;
      },
    },
    {
      dataField: "gender",
      text: "gender",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gender || "-"}</span>;
      },
    },
    {
      dataField: "weight",
      text: "weight",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {fixedTwo(row?.weight || 0)} KG
          </span>
        );
      },
    },
    {
      dataField: "height",
      text: "height",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {fixedTwo(row?.height || 0)} CM
          </span>
        );
      },
    },
    {
      dataField: "body_type",
      text: "body type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.body_type || "-"}</span>;
      },
    },
    {
      dataField: "how_active",
      text: "how active",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.how_active || "-"}</span>;
      },
    },
    {
      dataField: "bmi_result",
      text: "BMI",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{fixedTwo(row?.bmi_result || 0)}</span>
        );
      },
    },
    {
      dataField: "fat_result",
      text: "Fat",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{fixedTwo(row?.fat_result || 0)}</span>
        );
      },
    },
    {
      dataField: "tdee",
      text: "TDEE",
      formatter: (_, row) => {
        return <span className="tb-data">{fixedTwo(row?.tdee || 0)}</span>;
      },
    },
    {
      dataField: "calorie_result",
      text: "calorie",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{fixedTwo(row?.calorie_result || 0)}</span>
        );
      },
    },
    {
      dataField: "calorie_target_result",
      text: "target calorie",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {fixedTwo(row?.calorie_target_result || 0)}
          </span>
        );
      },
    },
    {
      dataField: "goal",
      text: "goal",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.goal || "-"}</span>;
      },
    },
    {
      dataField: "result_value",
      text: "result",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.result_value || "-"}</span>;
      },
    },
    {
      dataField: "is_new",
      text: "new",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.is_new ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
  ];

  const tbColumnsFeedbackLogs = [
    {
      dataField: "trainer_id",
      text: "trainer Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.trainer_name || "NA"}
            <br />
            <small className="lowercase underline">
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "user_id",
    //   text: "Rated by",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.user_name || "NA"}
    //         <br />
    //         <small style={{ textTransform: "lowercase" }}>
    //           {row?.user_mobile || ""}
    //           <br />
    //           {row?.user_email || ""}
    //         </small>
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "rating",
      text: "rating",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.rating || 0} ★</span>;
      },
    },
    {
      dataField: "comment",
      text: "comment",
      formatter: (_, row) => {
        return (
          <>
            {row?.comment?.length <= 30 ? (
              <span className="tb-data minWidth150">{row?.comment || "-"}</span>
            ) : (
              <span className="tb-data minWidth100">
                {row?.comment ? row.comment?.substring(0, 30) : "-"}{" "}
                {row?.comment && (
                  <b
                    className="link"
                    onClick={() =>
                      setClickValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "detailed_feedback",
                        remarks: row.comment,
                      }))
                    }
                  >
                    ...Read More
                  </b>
                )}
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail  Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/_/g, " ")}`}
            onClose={onCloseModal}
          />

          {clickValues.cardName === "detailed_feedback" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {clickValues.remarks || "No Content Available"}
              </p>
            </div>
          ) : null}
        </div>
      </Modal>

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allDetailData}
          tableColumns={
            from === "fitness_profile_logs"
              ? tbColumnsFitnessLogs
              : from === "trainer_rating_logs"
              ? tbColumnsFeedbackLogs
              : []
          }
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default DetailedLogs;
